<template>
  <div class="memberCenter flex">
    <div class="top">
      <div class="middle pt30">
        <div class="headimg circle">
          <van-image width="60px" height="60px" round lazy-load style="background:#fff;"
            :src="CustomerInfo&&CustomerInfo.Logo?_getPic(CustomerInfo.Logo,true):require('@/assets/mine/user.png')" fit="scale-down" />
        </div>
      </div>
      <div class="username middle">{{CustomerInfo?_truncature(CustomerInfo.CustomerName,7) :''}}</div>
      <div class="service middle mt30 text-left">
        <van-row class="mt10" type="flex" justify="space-around">
          <van-col class="kf2 f12 fw400 text-center" span="7">专属客服</van-col>
          <van-col class="ellipsis-row1" span="5">{{CustomerBusiness&&CustomerBusiness.Name}}</van-col>
          <van-col span="10">{{CustomerBusiness&&CustomerBusiness.Phone}}</van-col>
        </van-row>
        <van-row class="mt10" type="flex" justify="space-around">
          <van-col class="kf1 f12 fw400 text-center" span="7">业务人员</van-col>
          <van-col class="ellipsis-row1" span="5">{{CustomerService&&CustomerService.Name}}</van-col>
          <van-col class="kf-phone" span="10">{{CustomerService&&CustomerService.Phone}}</van-col>
        </van-row>
      </div>
    </div>
    <div class="bottom">
      <van-row type="flex" class="mt70 text-left" justify="space-around">
        <van-col span="7"></van-col>
        <van-col span="4">
          <span class="fAkrobat">
            <font class="f24">￥</font>234.09
          </span>
          <p class="ti flex align-items-center mt10">累计毛利</p>
        </van-col>
        <van-col span="3">
          <span class="fAkrobat c222i">{{CouponCount?CouponCount:0}}</span>
          <p class="ti flex align-items-center mt10">
            优惠券
            <van-icon :name="require('../assets/storey/in_gary.png')" size="14px" />
          </p>
        </van-col>
        <van-col span="3">
          <span class="fAkrobat c222i">{{PurchasedGoodsCount?PurchasedGoodsCount:0}}</span>
          <p class="ti flex align-items-center mt10">
            常购商品
            <van-icon :name="require('../assets/storey/in_gary.png')" size="14px" />
          </p>
        </van-col>
        <van-col span="3">
          <span class="fAkrobat c222i">{{MyFavouriteCount?MyFavouriteCount:0}}</span>
          <p class="ti flex align-items-center mt10">
            收藏商品
            <van-icon :name="require('../assets/storey/in_gary.png')" size="14px" />
          </p>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
  import { BaseMixin } from "../mixins/BaseMixin";
  export default {
    mixins: [BaseMixin],
    name: "MemberCenter",
    data() {
      return {
        CustomerInfo: null,
        CouponCount: null,
        MyFavouriteCount: null,
        PurchasedGoodsCount: null,
        CustomerInfoTestData: {
          EmployeeTypeName: "专属客服",
          Name: "测试",
          Phone: "139800000000"
        },
        CustomerService: null,
        CustomerBusiness: null,
        urls: {
          //根据联系人获取客户信息
          getCustomerInfo: "/api_customers/Customer/GetCustomerEmployee",
          //获取客户信息
          getCustomerContactDetail: "/api_customers/Customer/CustomerContactDetail",
          //我的优惠券
          getCouponCount: "/api_coupon/Coupon/GetMyCoupons",
          //我的收藏
          getMyFavouriteCount: "/api_customer/CustomerCollect/List",
          //常购商品
          getPurchasedGoods: "/api_order/Orders/GetPurchasedGoods"
        }
      };
    },
    created() {
      this.onRefresh();
    },
    async mounted() {},
    methods: {
      async onRefresh() {
        // 获取客户信息
        await this.getCustomerInfo();
        // 获取客户 服务业务员或者客服
        this.getCustomerEmployee();
        // 获取优惠券统计
        this.getCouponCount();
        //获取常购商品
        this.getPurchasedGoods();
      },
      // 获取客户信息
      async getCustomerInfo() {
        this.$hys.openLoading();
        const res = await this.getAction(this.urls.getCustomerContactDetail);
        this.$hys.clearLoading();
        if (res.IsSuccess && res.Data) {
          this.CustomerInfo = res.Data;
          this.auth.setCustomerId(
            this.CustomerInfo ? this.CustomerInfo.CustomerId : null
          );
          this.auth.setCustomerInfo(this.CustomerInfo ? this.CustomerInfo : null);
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
      },
      // 获取客户 服务业务员或者客服
      async getCustomerEmployee() {
        const res = await this.getAction(this.urls.getCustomerInfo);
        if (res.IsSuccess && res.Data) {
          let result = res.Data.filter(
            tag =>
            tag.EmployeeType == 1 ||
            tag.EmployeeType == 2 ||
            tag.EmployeeType == 3
          );
          this.CustomerService = result.find(tag => tag.EmployeeType == 1);
          this.CustomerBusiness = result.find(tag => tag.EmployeeType == 2);
          this.CustomerService = this.CustomerService ?
            this.CustomerService :
            this.CustomerInfoTestData;
          this.CustomerBusiness = this.CustomerBusiness ?
            this.CustomerBusiness :
            this.CustomerInfoTestData;
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
      },
      // 获取优惠券统计
      async getCouponCount() {
        const res = await this.getAction(this.urls.getCouponCount, {
          enumCollectType: 1,
          pageNo: 1,
          pageSize: 10
        });
        if (res.IsSuccess && res.Data) {
          this.CouponCount = res.Count;
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
      },
      //我的收藏
      async getMyFavouriteCount() {
        const res = await this.getAction(this.urls.getMyFavouriteCount, {
          pageNo: 1,
          pageSize: 10
        });
        if (res.IsSuccess && res.Data) {
          this.MyFavouriteCount = res.Count;
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
      },
      //getPurchasedGoods
      async getPurchasedGoods() {
        const res = await this.getAction(this.urls.getPurchasedGoods, {
          pageNo: 1,
          pageSize: 10
        });
        if (res.IsSuccess && res.Data) {
          this.PurchasedGoodsCount = res.Count;
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .memberCenter {
    box-shadow: 0px 8px 12px 0px rgba(238, 238, 238, 0.5);
    margin-left: 20px;
    height: 260px;
    font-size: 14px;
    text-align: center;
    width: calc(100% - 20px);
    float: left;
    font-family: PingFangSC-Regular, PingFang SC;
    border-radius: 2px;
    overflow: hidden;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    margin-bottom: 20px;

    .top {
      background: #62a6fd;
      height: 260px;
      width: 260px;
      //display: none;
      position: absolute;
      -moz-background-size: 100% 100%;
      background-size: 100% 100%;
      background-image: url("../assets/mine/gerenzhongxin-bg.png");

      .headimg {
        width: 60px;
        height: 60px;
        background: rgba(222, 244, 254, 1);
        box-shadow: 0px 2px 6px 0px rgba(12, 70, 145, 1);
        border: 2px solid rgba(255, 255, 255, 1);
        // background-image: url(../assets/login/normal.png);
        background-size: cover;
      }

      .username {
        margin: 10px auto;
        border: 0px solid blue;
        font-size: 18px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 25px;
      }

      .service {
        width: 240px;
        height: 68px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 2px;
        //opacity: 0.3;
        border: 1px solid rgba(255, 255, 255, 0);
        color: white;

        .kf1 {
          width: 60px;
          height: 18px;
          background: linear-gradient(318deg,
              rgba(119, 153, 255, 1) 0%,
              rgba(83, 111, 238, 1) 100%);
          border-radius: 1px;
        }

        .kf2 {
          width: 60px;
          height: 18px;
          background: linear-gradient(313deg,
              rgba(85, 159, 255, 1) 0%,
              rgba(17, 126, 232, 1) 100%);
          border-radius: 1px;
        }
      }
    }

    .bottom {
      background: white;
      height: 206px;
      width: 100%;
      float: right;
      top: 0;
      bottom: 0;
      margin: auto;

      .ti {
        // width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 20px;
      }

      span {
        width: 99px;
        height: 29px;
        font-size: 36px;
        font-weight: bold;
        color: rgba(255, 133, 28, 1);
        line-height: 29px;
      }

      .blist {
        padding-top: 20px;

        span {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 20px;
        }

        h {
          width: 21px;
          height: 29px;
          font-size: 24px;
          font-weight: 900;
          color: rgba(51, 51, 51, 1);
          line-height: 29px;
        }
      }
    }
  }

  .circle {
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
  }

  .middle {
    left: 0;
    right: 0;
    margin: auto;
  }

  .v-middle {
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .mt70 {
    margin-top: 70px;
  }

  .mt30 {
    margin-top: 30px;
  }

  .f12 {
    font-size: 12px;
  }

  .c222i {
    color: #222222 !important;
  }
</style>